module.exports = __webpack_public_path__ + "static/media/inside-car-color.2a8ee42d.jpg";